import { useEffect, useMemo, useState } from 'react';
import { extractListPhotos } from '../utils/result-image.utils';
import { TVehiculeCheckResultCheckPointSchema } from '@/schemas/vehicule-check-result/vehicule-check-check-point.schema';

export const useResultPhotoMenuEffect = (
  menuRef: React.RefObject<HTMLDivElement>
) => {
  const [isPhotoHovered, setIsPhotoHovered] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuRef, isMenuOpen]);

  return {
    isPhotoHovered,
    isMenuOpen,
    setIsPhotoHovered,
    setIsMenuOpen,
  };
};

export const useResultImageList = (
  results: TVehiculeCheckResultCheckPointSchema[],
  property: 'equipments' | 'damages' | 'vehicules'
) => {
  return useMemo(
    () => extractListPhotos(results, property),
    [results, property]
  );
};
